import { Card, CardContent } from "@mui/material";
import { ClearAll, Search } from "@mui/icons-material";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabPanel from "@mui/lab/TabPanel";
import { useTheme } from "@emotion/react";
import FormSearch from "./FormSearch";
import FormSearchImagenologia from "./FormSearchImagenologia";
import FormSearchProcedimiento from "./FormSearchProcedimiento";
import {
  useRecoilState,
  useRecoilValue,
  useResetRecoilState,
  useSetRecoilState,
} from "recoil";
import { activeTabState, existPatientState } from "./state/atoms";
import React, { useState } from "react";

import { useNavigate } from "react-router-dom";

import TabsCustom from "src/shared/components/tabs/TabsCustom";
import ButtonCustom from "../shared/components/buttons/ButtonCustom";
import {
  filterSearchSelectedState,
  hoursAvailableState,
  professionalsMatchCovenantState,
  professionalsNoMatchCovenantState,
} from "./state/atoms";
import ReactGA from "react-ga4";
import useLoadData from "./hooks/useLoadData";
import { valuesFormReservationGuestState } from "src/Patient/state/atoms";
import { userState } from "src/store/user/userState";
import { validateRutChilean } from "src/shared/global/helpers";
import AgendamientoInconcluso from "src/services/agenda/agendamientoInconcluso";
import { agendamientoInconclusoState } from "src/ResultSearch/state/atoms";
import { dayDefaultAvailableState } from "./components/calendars/state/atoms";

export default function TabsSearch() {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const valuesFormReservationGuest = useRecoilValue(
    valuesFormReservationGuestState
  );
  const user = useRecoilValue(userState);

  const [activeTabSearch, setActiveTabSearch] = useRecoilState(activeTabState);
  const theme = useTheme();

  const filterSearchSelected = useRecoilValue(filterSearchSelectedState);
  const resetFilterSearchSelected = useResetRecoilState(
    filterSearchSelectedState
  );
  const resetProfessionalsMatchCovenant = useResetRecoilState(
    professionalsMatchCovenantState
  );
  const resetProfessionalsNoMatchCovenant = useResetRecoilState(
    professionalsNoMatchCovenantState
  );
  const resetHoursAvailable = useResetRecoilState(hoursAvailableState);
  const { loadData, loadingData } = useLoadData();

  const setValueAgendamientoInconcluso = useSetRecoilState(
    agendamientoInconclusoState
  );

  const [tabsDisabled, setTabsDisabled] = useState({
    one: false,
    two: false,
  });

  const handleChangeTab = (event, newValue) => {
    resetFilterSearchSelected();
    setActiveTabSearch(newValue);
  };

  const eventGA = () => {
    let especialidad = filterSearchSelected.specialitySelected.value;
    especialidad = especialidad != "" ? `Especialidad: ${especialidad}` : "";
    let profesional = filterSearchSelected.professionalSelected.value;
    profesional = profesional != "" ? `| Profesional: ${profesional}` : "";
    let prevision = filterSearchSelected.covenantSelected.value;
    prevision = prevision != "" ? `| Previsión: ${prevision}` : "";
    ReactGA.event({
      category: "Buscar",
      action: `${especialidad} ${profesional} ${prevision}`,
    });
  };

  const eventImagenologiaGA = () => {
    let tipoExamen = filterSearchSelected.tipoExamenSelected.value;
    tipoExamen = tipoExamen != "" ? `TipoExamen: ${tipoExamen}` : "";
    let examen = filterSearchSelected.examenSelected.value;
    examen = examen != "" ? `| Examen: ${examen}` : "";
    ReactGA.event({
      category: "Buscar",
      action: `${tipoExamen} ${examen}`,
    });
  };

  const disableButton = () => {
    const {
      professionalSelected,
      specialitySelected,
      examenSelected,
      procedimientoSelected,
      servicioSelected,
    } = filterSearchSelected;
    const { uprRut } = valuesFormReservationGuest;
    const isValidRut = uprRut ? validateRutChilean(uprRut).ok : false;
    let flag = false;
    if (activeTabSearch === "1") {
      flag =
        (professionalSelected.value !== "" ||
          specialitySelected.value !== "") &&
        (user.isAuthenticated || isValidRut);
    } else if (activeTabSearch === "2") {
      flag =
        examenSelected.value !== "" &&
        filterSearchSelected.tipoExamenSelected.value !== "" &&
        (user.isAuthenticated || isValidRut);
    } else if (activeTabSearch === "3") {
      flag =
        procedimientoSelected.value !== "" &&
        servicioSelected.value !== "" &&
        (user.isAuthenticated || isValidRut);
    }

    return !flag;
  };

  const setExistPatient = useSetRecoilState(existPatientState);
  const getPatient = async (rut) => {
    try {
      const { data } = await AgendamientoInconcluso.existPatient(rut);
      setExistPatient(data);
      return data;
    } catch (error) {
      console.log(error);
      return null;
    }
  };

  return (
    <Box
      sx={{ width: "100%", typography: "body1" }}
      style={{
        marginTop: "1rem",
        marginBottom: "2rem",
      }}
    >
      <TabContext value={activeTabSearch}>
        <Box>
          <TabsCustom
            theme={theme}
            onChange={handleChangeTab}
            aria-label="lab API tabs example"
            variant="scrollable"
            scrollButtons
            allowScrollButtonsMobile
          >
            <Tab label="HORA MÉDICA" value="1" disabled={tabsDisabled["one"]} />
            <Tab
              label="IMAGENOLOGÍA"
              value="2"
              disabled={tabsDisabled["two"]}
            />
            {/* <Tab
              label="PROCEDIMIENTOS"
              value="3"
              disabled={tabsDisabled["tree"]}
            /> */}
          </TabsCustom>
        </Box>
        <TabPanel
          value="1"
          className="formularioNuevo"
          style={{
            padding: "0px",
          }}
        >
          {/* <FormLogin xs={12} sm={6} /> */}
          <Card
            style={{
              borderTopLeftRadius: "0px",
              borderTopRightRadius: "0px",
            }}
          >
            <CardContent>
              <FormSearch />
            </CardContent>

            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                p: 2,
              }}
            >
              <ButtonCustom
                disabled={disableButton()}
                loading={loading}
                color="secondary"
                text="BUSCAR"
                icon={<Search />}
                style={{ marginRight: 15 }}
                onClick={async () => {
                  setLoading(true);
                  resetProfessionalsMatchCovenant();
                  resetProfessionalsNoMatchCovenant();
                  resetHoursAvailable();
                  eventGA();
                  setValueAgendamientoInconcluso({
                    sueCorrel:
                      filterSearchSelected.sucursalSelected.sue_correl?.toString(),
                    empCodigo:
                      filterSearchSelected.sucursalSelected.emp_codigo?.toString(),
                    espCodigo:
                      filterSearchSelected.specialitySelected.code?.toString(),
                    tapTipo:
                      filterSearchSelected.modalidadSelected.tipo?.toString(),
                    exaCorrel:
                      filterSearchSelected.procedimientoSelected.code?.toString(),
                    aseCorrel:
                      filterSearchSelected.servicioSelected.code?.toString(),
                    isaCodigo:
                      filterSearchSelected.covenantSelected.code?.toString(),
                    agiTipo: "CEM",
                  });
                  await getPatient(valuesFormReservationGuest.uprRut);
                  await new Promise((resolve) => setTimeout(resolve, 1000));
                  navigate(
                    `${process.env.REACT_APP_ROOT_SERVER_PATH}/resultado-busqueda`
                  );
                }}
              />
              <ButtonCustom
                color="default"
                variant="contained"
                text="LIMPIAR"
                icon={<ClearAll />}
                onClick={() => {
                  resetFilterSearchSelected();
                  loadData(1);
                }}
              />
            </Box>
          </Card>
        </TabPanel>
        <TabPanel
          value="2"
          style={{
            padding: "0px",
          }}
        >
          <Card
            style={{
              borderTopLeftRadius: "0px",
              borderTopRightRadius: "0px",
            }}
          >
            <CardContent>
              <FormSearchImagenologia />
            </CardContent>

            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                p: 2,
              }}
            >
              <ButtonCustom
                disabled={disableButton()}
                loading={loading}
                color="secondary"
                text="BUSCAR"
                icon={<Search />}
                style={{ marginRight: 15 }}
                onClick={async () => {
                  setLoading(true);
                  resetProfessionalsMatchCovenant();
                  resetProfessionalsNoMatchCovenant();
                  resetHoursAvailable();
                  eventImagenologiaGA();
                  setValueAgendamientoInconcluso({
                    sueCorrel:
                      filterSearchSelected.sucursalSelected.sue_correl?.toString(),
                    empCodigo:
                      filterSearchSelected.sucursalSelected.emp_codigo?.toString(),
                    espCodigo:
                      filterSearchSelected.specialitySelected.code?.toString(),
                    tapTipo:
                      filterSearchSelected.modalidadSelected.tipo?.toString(),
                    exaCorrel:
                      filterSearchSelected.procedimientoSelected.code?.toString(),
                    aseCorrel:
                      filterSearchSelected.servicioSelected.code?.toString(),
                    isaCodigo:
                      filterSearchSelected.covenantSelected.code?.toString(),
                    agiTipo: "IMG",
                  });
                  await getPatient(valuesFormReservationGuest.uprRut);
                  await new Promise((resolve) => setTimeout(resolve, 1000));
                  navigate(
                    `${process.env.REACT_APP_ROOT_SERVER_PATH}/resultado-busqueda-imagenologia`
                  );
                }}
              />
              <ButtonCustom
                color="default"
                variant="contained"
                text="LIMPIAR"
                icon={<ClearAll />}
                onClick={() => {
                  resetFilterSearchSelected();
                  loadData(2);
                }}
              />
            </Box>
          </Card>
        </TabPanel>
        <TabPanel
          value="3"
          style={{
            padding: "0px",
          }}
        >
          <Card
            style={{
              borderTopLeftRadius: "0px",
              borderTopRightRadius: "0px",
            }}
          >
            <CardContent>
              <FormSearchProcedimiento />
            </CardContent>

            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                p: 2,
              }}
            >
              <ButtonCustom
                disabled={disableButton()}
                loading={loading}
                color="secondary"
                text="BUSCAR"
                icon={<Search />}
                style={{ marginRight: 15 }}
                onClick={async () => {
                  setLoading(true);
                  resetProfessionalsMatchCovenant();
                  resetProfessionalsNoMatchCovenant();
                  resetHoursAvailable();
                  setValueAgendamientoInconcluso({
                    sueCorrel:
                      filterSearchSelected.sucursalSelected.sue_correl?.toString(),
                    empCodigo:
                      filterSearchSelected.sucursalSelected.emp_codigo?.toString(),
                    espCodigo:
                      filterSearchSelected.specialitySelected.code?.toString(),
                    tapTipo:
                      filterSearchSelected.modalidadSelected.tipo?.toString(),
                    exaCorrel:
                      filterSearchSelected.procedimientoSelected.code?.toString(),
                    aseCorrel:
                      filterSearchSelected.servicioSelected.code?.toString(),
                    isaCodigo:
                      filterSearchSelected.covenantSelected.code?.toString(),
                    agiTipo: "PCD",
                  });
                  await getPatient(valuesFormReservationGuest.uprRut);
                  await new Promise((resolve) => setTimeout(resolve, 1000));
                  navigate(
                    `${process.env.REACT_APP_ROOT_SERVER_PATH}/resultado-busqueda-procedimiento`
                  );
                }}
              />
              <ButtonCustom
                color="default"
                variant="contained"
                text="LIMPIAR"
                icon={<ClearAll />}
                onClick={() => {
                  resetFilterSearchSelected();
                  loadData(3);
                }}
              />
            </Box>
          </Card>
        </TabPanel>
      </TabContext>
    </Box>
  );
}
